import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  setClientsSelectedActiveExpedition,
  setClientsSelectedActiveExpeditionForNode,
  setClientsSelectedActiveExpeditionForPickUpRoute,
} from "../../../../redux/reducer/expedition.reducer";
import NodeTransferActiveExpeditionModal from "../NodeTransferActiveExpeditionModal";
import RouteTransferActiveExpeditionModal from "../RouteTransferActiveExpeditionModal";
import PickUpRouteTransferActiveExpeditionModal from "../PickUpRouteTransferActiveExpeditionModal";

const CustomHeaderComponent = () => {
  const { selectedItems } = useTableCtx() || {};

  const dispatch = useAppDispatch();
  const {
    expedition: {
      clientsSelectedActiveExpedition,
      clientsSelectedActiveExpeditionForNode,
      clientsSelectedActiveExpeditionForPickUpRoute,
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
    transport: state.transport,
  }));

  const handleOpenRouteModal = () => {
    if (selectedItems?.length) {
      dispatch(setClientsSelectedActiveExpedition(selectedItems));
    }
  };

  const handleOpenNodeModal = () => {
    if (selectedItems?.length) {
      dispatch(setClientsSelectedActiveExpeditionForNode(selectedItems));
    }
  };

  const handleOpenPickUpRouteModal = () => {
    if (selectedItems?.length) {
      dispatch(setClientsSelectedActiveExpeditionForPickUpRoute(selectedItems));
    }
  };

  const hasSelection = Boolean(selectedItems?.length);
  const items: ActionMenuItem[] = [
    {
      id: "pickup-route",
      label: "Ruta preluare",
      icon: "CHANGE_ROUTE",
      color: "warning",
      tooltip:
        "Deschide schimbarea rutei de preluare pentru expeditiile selectate.",
      onClick: handleOpenPickUpRouteModal,
    },
    {
      id: "route-transfer",
      label: "Transfer ruta",
      icon: "TRANSFER",
      tooltip: "Deschide transferul expeditiilor selectate pe alta ruta.",
      onClick: handleOpenRouteModal,
    },
    {
      id: "node-transfer",
      label: "Transfer nod",
      icon: "TRANSFER_NODE",
      tooltip: "Deschide transferul expeditiilor selectate catre alt nod.",
      onClick: handleOpenNodeModal,
    },
  ];

  return (
    <>
      {hasSelection && (
        <div className="mb-3 flex flex-wrap items-center justify-end gap-3">
          <ActionMenu
            items={items}
            minItemsForMenu={10}
            title={`${selectedItems?.length ?? 0} expeditii selectate`}
            ariaLabel="Actiuni pentru expeditiile selectate"
          />
        </div>
      )}
      {clientsSelectedActiveExpedition.length > 0 && (
        <RouteTransferActiveExpeditionModal />
      )}
      {clientsSelectedActiveExpeditionForNode.length > 0 && (
        <NodeTransferActiveExpeditionModal />
      )}
      {clientsSelectedActiveExpeditionForPickUpRoute.length > 0 && (
        <PickUpRouteTransferActiveExpeditionModal />
      )}
    </>
  );
};

export default CustomHeaderComponent;
